import React, { useMemo } from 'react'
import { ContainerField, CheckBoxField } from '@sencha/ext-modern'

import { genFullListName, getMixedProps } from './blockPublic'
import { showContextMenu } from '../../column/contextmenu'
import { useEventHandler, useInstData } from 'tyan/public/hooks'
import { isEqual, sortBy } from 'lodash'

// 取Field的requiredMessage信息
// let requiredMessage = 'required'
// Tyan.onReady(()=>(requiredMessage = Ext.field.Field.getConfigurator().values.requiredMessage))

const CheckBox = ({ config: { field, onChange: _onChange, initValues, changedValues, defaultStyle, that, that: { state: { _validStamp } } } }) => {
	const { props: { required, ...props } } = getMixedProps('_checkbox', [defaultStyle, field])
	const { me, me: { edited = false } } = useInstData()
	let { items, name, list, optionName, value: fieldValue } = field
	const fullName = genFullListName(list, name)
	const optionsParas = { ...that.props.optionsParas, ...that.state.optionsParas }
	const initValue = initValues && initValues[fullName] || []
	const itemsAdd = []
	items = items || optionsParas[optionName || name] || []
	items = items.map(item => Array.isArray(item) ? item : [item, item])
	fieldValue = fieldValue && Array.isArray(fieldValue) && fieldValue || []
	fieldValue = me.fieldValue = isEqual(fieldValue, me.fieldValue) ? me.fieldValue : fieldValue
	initValue.forEach(item => !items.find(([, value]) => item == value) && itemsAdd.push([item, item, { 'text-decoration': 'line-through' }]))
	const { props: { itemMinWidth, itemNoLocale, itemMargin, ...itemProps } } = getMixedProps('_checkboxItem', [defaultStyle, field])
	let allItemValues = itemsAdd.concat(items).map(([, value]) => value)
	allItemValues = me.allItemValues = isEqual(me.allItemValues, allItemValues) ? me.allItemValues : allItemValues
	const onChange = (...args) => {
		me.edited = true
		return _onChange(...args)
	}

	const handleCheckAll = () => {
		// console.log('checkAll:', me.allItemValues, [...me.fieldValue], [...allItemValues])
		onChange({ name, newValue: [...me.allItemValues], type: 'array' })
	}

	const handleUncheckAll = () => {
		// console.log('uncheckAll:', me.allItemValues, [...me.fieldValue], [])
		onChange({ name, newValue: [], type: 'array' })
	}

	const handleCheckReverse = () => {
		// console.log('checkReverse:', me.allItemValues, [...me.fieldValue], me.allItemValues.filter(v => !fieldValue.includes(v)))
		onChange({ name, newValue: me.allItemValues.filter(v => !me.fieldValue.includes(v)), type: 'array' })
	}

	const handlerCheckBoxChange = (itemValue) => (field, bSelected) => {
		// console.log('change:', me.allItemValues, me.fieldValue, itemValue, bSelected)
		true && (bSelected ? !me.fieldValue.includes(itemValue) : me.fieldValue.includes(itemValue))
			&& onChange({
				name,
				newValue: me.allItemValues.filter(v => bSelected ? (itemValue === v || me.fieldValue.includes(v)) : (itemValue !== v && me.fieldValue.includes(v))),
				type: 'array'
			})
	}

	const handleContextMenu = useEventHandler(e => {
		if (items.length <= 2) return
		e.stopEvent()
		showContextMenu(e.getXY(), [
			{ text: '全选', ui: 'action', handler: handleCheckAll, disabled: fieldValue.length == allItemValues.length },
			{ text: '全不选', ui: 'action', handler: handleUncheckAll, disabled: !fieldValue.length },
			{ text: '反选', ui: 'action', handler: handleCheckReverse }
		])
	})

	const listeners = useMemo(() => ({
		contextmenu: { element: 'bodyElement', fn: handleContextMenu },
		longpress: { element: 'bodyElement', fn: handleContextMenu }
	}), [])

	return <ContainerField {...props} required={required}
		errorMessage={required && (_validStamp || edited) && !fieldValue.length ? '这是一个必填项' : ''}
		errorTarget='side'
		listeners={listeners}
	>
		{items.concat(itemsAdd).map(([label, value, style, tooltip], index) => <CheckBoxField {...itemProps}
			{...{
				key: `${value}${index}`, boxLabel: label, value, style, tooltip,
				minWidth: itemMinWidth, noLocale: itemNoLocale, margin: itemMargin, checked: fieldValue.includes(value)
			}}
			onChange={handlerCheckBoxChange(value)} />)}
		{/* {itemsAdd.map((item, key) => <CheckBoxField noLocale={itemNoLocale} {...itemProps} minWidth={itemMinWidth} boxLabel={item} key={key + items.length}
			checked={fieldValue.includes(item)}
			onChange={handlerCheckBoxChange(name, item, initValues[name], { ...initValues, ...changedValues }[name], onChange)}
			style={style} />)} */}
	</ContainerField>
}

const renderCheckBox = config => {
	const { field: { key } } = config
	return <CheckBox key={key} config={config} />
}

export default renderCheckBox